import { AlertTriangle, RotateCw } from "lucide-react";
import { BrandSpinner } from "@/components/BrandSpinner";

/**
 * One friendly way to say "that didn't load" anywhere on the signed-in pages.
 * Pilots never see raw error strings — just what happened and a way forward.
 */
export function InlineError({
  title = "That didn't load",
  message = "Something went wrong on our side. Give it another go.",
  onRetry,
  retrying = false,
  className = "",
}: {
  title?: string;
  message?: string;
  onRetry?: () => void;
  retrying?: boolean;
  className?: string;
}) {
  return (
    <div role="alert" className={`rounded-xl border border-border bg-card/60 p-5 ${className}`}>
      <div className="flex items-start gap-3">
        <AlertTriangle className="mt-0.5 size-5 shrink-0 text-warning" />
        <div className="min-w-0">
          <p className="font-display text-base font-semibold">{title}</p>
          <p className="mt-1 text-sm text-muted-foreground">{message}</p>
          {onRetry && (
            <button
              type="button"
              onClick={onRetry}
              disabled={retrying}
              className="mt-4 inline-flex min-h-11 items-center gap-2 rounded-lg border border-border px-4 py-2 text-sm font-medium hover:bg-muted disabled:opacity-50"
            >
              {retrying ? <BrandSpinner size="sm" /> : <RotateCw className="size-4" />}
              Try again
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
